import { ArrowRight, Phone, MapPin } from "lucide-react";
import { useParallax } from "../lib/useParallax";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/ld7h61jm_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM%20%282%29.jpeg";

export default function Hero() {
  const bgRef = useParallax(-0.18);
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      {/* Background image with Ken Burns + scroll parallax */}
      <div ref={bgRef} className="absolute -inset-y-[10%] inset-x-0 will-change-transform">
        <div className="absolute inset-0 animate-kenburns">
          <img
            src={HERO_IMG}
            alt="Cows at Hastkesar Panjrapole"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Dark gradient overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(27,77,62,0.55) 0%, rgba(20,60,48,0.45) 45%, rgba(20,46,36,0.85) 100%)",
        }}
      />

      {/* Decorative grain */}
      <div
        className="absolute inset-0 opacity-[0.12] mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence baseFrequency='0.85' numOctaves='2' /></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 min-h-[100svh] flex flex-col justify-end pb-16 pt-32">
        <div className="max-w-4xl">
          <div className="flex items-center gap-3 mb-8 reveal is-visible">
            <span className="h-[1px] w-12 bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs tracking-[0.35em] uppercase font-medium">
              Est. by the Bokadia Family
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-display text-[#FDFBF7] text-5xl sm:text-6xl md:text-7xl lg:text-[92px] leading-[1.02] tracking-tight"
          >
            Lives Protected.
            <br />
            <span className="italic text-[#D4AF37]">Compassion</span> Without Limits.
          </h1>

          <p className="mt-8 text-[#FDFBF7]/85 text-base sm:text-lg max-w-2xl leading-relaxed">
            Hastkesar Panjrapole is a living home — an animal hospital and
            home where cows, dogs, deer, rabbits and camels are healed,
            sheltered and remembered with dignity.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              href="#volunteer"
              data-testid="hero-volunteer-btn"
              className="group inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#B5952F] text-[#1A2E24] px-7 py-4 rounded-full text-sm font-semibold tracking-wide transition-all"
            >
              Volunteer With Us
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="tel:+918141646161"
              data-testid="hero-emergency-btn"
              className="inline-flex items-center gap-3 border border-[#FDFBF7]/40 hover:bg-[#FDFBF7]/10 text-[#FDFBF7] px-7 py-4 rounded-full text-sm font-medium backdrop-blur-sm transition-all"
            >
              <Phone className="w-4 h-4" /> Emergency Help
            </a>
            <a
              href="#contact"
              data-testid="hero-visit-btn"
              className="inline-flex items-center gap-2 text-[#FDFBF7] text-sm font-medium border-b border-[#FDFBF7]/40 pb-1 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
            >
              <MapPin className="w-4 h-4" /> Visit Us
            </a>
          </div>
        </div>

        {/* bottom meta strip */}
        <div className="mt-16 border-t border-[#FDFBF7]/15 pt-6 flex flex-wrap gap-x-10 gap-y-3 text-[#FDFBF7]/70 text-xs tracking-[0.18em] uppercase">
          <span>Animal Hospital</span>
          <span className="text-[#D4AF37]">•</span>
          <span>Gaushala</span>
          <span className="text-[#D4AF37]">•</span>
          <span>Rescue & Rehab</span>
          <span className="text-[#D4AF37]">•</span>
          <span>24/7 Emergency</span>
        </div>
      </div>
    </section>
  );
}
